import React from 'react';
import '../../../Static/Master/SalepartyReg.css';


const SearchPagination = ({ handleRecordsPerPageChange, handleFilterByName, filterName }) => {
    return (
        <>
            <div className='div-select'>
                <span>Show</span>
                <select onClick={handleRecordsPerPageChange} id='select'>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <span>Entries</span>

                <label className="input-label1"> Search : <input id='inpt' type="text" placeholder="Search"

                    value={filterName !== 'null' ? filterName.toUpperCase() : ''} onChange={handleFilterByName} /> </label>


            </div>
        </>
    );
}

export default React.memo(SearchPagination);
